import React, { Component } from "react";
import { PGService } from "../../Remote/PowerGym";
import { showLoadingBar, hideLoadingBar } from "../../Redux/actions/loading";
import { connect } from "react-redux";
import { showSnackbar } from "../../Redux/actions/snackbar";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import BookingList from "./BookingList/BookingList";
import { withNamespaces } from "react-i18next";
import "./MyBookings.css";
import MyDialog from "../Common/MyDialog";

class MyBookings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bookings: null,
      error: null,
      booking_id: null,
      modal: {
        showModal: false,
        title: "",
        message: "",
      },
    };
  }

  componentDidMount() {
    this.loadBookings();
  }

  /**
   * Performs the API call to get players from server. Also, set loading true to show the spinner component
   */
  loadBookings = () => {
    this.props.showLoadingBar();

    PGService.myBookings()
      .then((response) => {
        this.setState({
          bookings: response.data.timetables || [],
          error: null,
        });
        this.props.hideLoadingBar();
      })
      .catch((e) => {
        this.props.hideLoadingBar();
        this.setState({
          error:
            "Hemos detectado un problema de comunicación. Verifique su conexión a internet y vuelva a intentarlo",
        });
      });
  };

  handleRemoveBooking = (id) => {
    this.setState({
      modal: {
        showModal: true,
        title: this.props.t("Remove booking"),
        message: this.props.t("Are you sure?"),
      },
      booking_id: id,
    });
  };

  /**
   *
   */
  handleAgree = () => {
    this.props.showLoadingBar();

    if (!this.state.booking_id) {
        return;
    }

    PGService.removeBooking(this.state.booking_id).then((response) => {
      if (response.success === true) {
        this.setState((prevState) => ({
          bookings: prevState.bookings.filter((e) => e.id !== this.state.booking_id),
        }));
      }
      this.props.showSnackbar(response.message || "");
      this.props.hideLoadingBar();
    }).catch(e => {
        console.log("error" , e);
    });

    this.handleClose();
  };

  /**
   *
   */
  handleClose = () => {
    this.setState((prev) => ({
      modal: {
        ...prev.modal,
        showModal: false,
      },
    }));
  };

  render() {
    const { t } = this.props;
    const { bookings, error } = this.state;

    return (
      <div>
        <h2>{t("My Bookings")}</h2>
        <Fab
          color="primary"
          aria-label={t("Add")}
          component={Link}
          to="bookings/new"
          className="plusBtn"
        >
          <AddIcon />
        </Fab>

        {error && (
          <div>
            <p>{error}</p>
          </div>
        )}

        {!error && (
          <div>
            <BookingList
              handleRemoveBooking={this.handleRemoveBooking}
              bookings={bookings}
            />
          </div>
        )}
        <MyDialog
          {...this.state.modal}
          handleClose={this.handleClose}
          handleAgree={this.handleAgree}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = (dispatch) => ({
  showLoadingBar: () => dispatch(showLoadingBar()),
  hideLoadingBar: () => dispatch(hideLoadingBar()),
  showSnackbar: (message) => dispatch(showSnackbar(message)),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(MyBookings)
);
